export default __webpack_public_path__ + "static/media/photoprofil1.8de4a799.png";